<template>
  <div class="cont">
    <div class="banner">
      <div style="width:1200px;margin:0 auto;position: relative;">
        <p class="top_title">基本信息绑定</p>
      </div>
    </div>
    <div class="form_box" v-loading="loading">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
        class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select style="width:340px;" v-model="ruleForm.sex" placeholder="请选择性别">
                <el-option label="女" :value="1"></el-option>
                <el-option label="男" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="身份证号码" prop="idCard">
              <el-input v-model="ruleForm.idCard"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话号码" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 上传 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="请上传你的二代身份证" label-width="200px" prop="frontUrl">
              <el-upload class="avatar-uploader" :action="action" accept=".png, .jpg, .jpeg" list-type="picture-card"
                :show-file-list="false" :on-success="handleFrontUrlSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="ruleForm.frontUrl" :src="ruleForm.frontUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div v-show="!ruleForm.frontUrl" class="el-upload__tip" slot="tip">上传人像面</div>
                <span v-show="ruleForm.frontUrl" class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click.stop="handlePictureCardPreview(ruleForm.frontUrl, 0)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click.stop="handleRemove(fileUrl, 0)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="reverseUrl">
              <el-upload class="avatar-uploader" style="width:240px" :action="action" accept=".png, .jpg, .jpeg"
                list-type="picture-card" :show-file-list="false" :on-success="handleReverseUrlSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="ruleForm.reverseUrl" :src="ruleForm.reverseUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div v-show="!ruleForm.reverseUrl" class="el-upload__tip" slot="tip">上传国徽面</div>
                <span style="width:240px" v-show="ruleForm.reverseUrl" class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview"
                    @click.stop="handlePictureCardPreview(ruleForm.reverseUrl, 1)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click.stop="handleRemove(ruleForm.reverseUrl, 1)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </el-upload>
            </el-form-item>
          </el-col>

        </el-row>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { saveUserInfo } from '@/api/map/index'
export default {
  name: 'BasicInformationBinding',
  data() {
    return {
      ruleForm: {
        name: '',
        sex: '',
        idCard: '',
        phone: '',
        frontUrl: '',
        reverseUrl: '',
      },
      loading: false,
      disabled: false,
      dialogVisible: false,
      dialogImageUrl: '',
      openid: this.$route.params.openid,
      action: 'http://182.140.209.211:20021/zwmap/uploadMaterialFile',//上传接口地址
      rules: {
        name: [
          { required: true, message: '请输入你的真实姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        idCard: [
          { required: true, message: '请输入你的身份证号码', trigger: 'blur' },
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "请输入正确的身份证号码",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: '请输入你的电话号码', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        // frontUrl: [
        //   { required: true, message: '请上传你的身份证正面照片', trigger: 'blur' },
        // ],
        // reverseUrl: [
        //   { required: true, message: '请上传你的身份证反面照片', trigger: 'blur' },
        // ],
      }
    };
  },

  mounted() {
  },

  methods: {
    // 身份证正面上传成功钩子函数
    handleFrontUrlSuccess(response, file, fileList) {
      this.ruleForm.frontUrl = response.url;
      // console.log(response, file, fileList, '上传成功')
    },
    // 身份证反面上传成功钩子函数
    handleReverseUrlSuccess(response, file, fileList) {
      this.ruleForm.reverseUrl = response.url;
      console.log(response, file, fileList, '上传成功')
    },
    beforeAvatarUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ['png', 'PNG', 'JPG', 'jpg', 'jpeg'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error('上传文件只能是 jpg、jpeg、png格式');
        return false;
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return false;
      }
    },
    handleRemove(fileUrl, type) {
      console.log(fileUrl, type);
      if (type == 0) {
        this.ruleForm.frontUrl = '';
      } else {
        this.ruleForm.reverseUrl = '';
      }
    },
    handlePictureCardPreview(fileUrl, type) {
      console.log(fileUrl)
      this.dialogImageUrl = fileUrl;
      this.dialogVisible = true;
    },
    // 表单上传
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let obj = this.ruleForm;
          obj.openid = this.openid;
          if (!this.ruleForm.frontUrl || !this.ruleForm.reverseUrl) {
            this.$message('请上传身份证人像面/国徽面！');
            this.loading = false;
            return;
          } else {
            this.$confirm('身份信息绑定则不可修改，请确认身份证号码是否正确, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              saveUserInfo(obj).then(res => {
                // console.log(res, '绑定信息结果')
                if (res.data.code == 200) {
                  this.$message.success('登陆成功')
                  let userInfo = res.data.data.loginInfo
                  this.$store.commit('SET_NAME', userInfo.name);
                  this.$store.commit('SET_USERID', userInfo.userId);
                  this.$store.commit('SET_SEX', userInfo.sex);
                  this.$store.commit('SET_IDCARD', userInfo.idCard);
                  this.$store.commit('SET_PHONE', userInfo.phone);
                  this.$store.commit('SET_REVERSEURL', userInfo.reverseUrl);
                  this.$store.commit('SET_FRONTURL', userInfo.frontUrl);
                  localStorage.setItem('userInfo', JSON.stringify(userInfo))
                  localStorage.setItem('token', res.data.data.token);
                  this.$store.commit('SET_TOKEN', res.data.data.token);
                  this.loading = false;
                  // let fromPath = localStorage.getItem('fromPath');
                  // const {href} = this.$router.resolve({path: fromPath});
                  // window.open(href, '_blank');
                  this.$router.push({
                    path: localStorage.getItem('fromPath')
                  })
                } else {
                  this.loading = false;
                  this.$message.error(res.data.msg)
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });
              this.loading = false;
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.ruleForm.name = '';
      this.ruleForm.sex = '';
      this.ruleForm.idCard = '';
      this.ruleForm.phone = '';
      this.ruleForm.frontUrl = '';
      this.ruleForm.reverseUrl = '';
    }
  },
  beforeRouteEnter(to, from, next) {
    let that = this;
    let userInfo = localStorage.getItem('userInfo')
    // to:获取你要跳转的路由信息
    // from: 获取你从哪个路由来的信息
    // next: （放行函数）
    if (from.path == '/LoginSuccess' && !userInfo) {  //从登录成功来并且没有用户信息，可以直接进入
      next();
    } else {
      next({ path: '/' });
    }
    // 第一种写法
    // next(); // 直接放行
    // 第二种
    // next('/url') //放行到指定的路由
  },
};
</script>
<style scoped>
.banner {
  width: 100%;
  height: 155px;
  background-size: 100% auto;
  position: absolute;
  top: 125px;
}

.top_title {
  font-size: 40px;
  color: #fff;
  font-weight: 700;
  text-align: left;
  position: absolute;
  top: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75%;
}

.form_box {
  width: 900px;
  margin: 0 auto;
  padding: 40px 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100%;
  height: auto;
  display: block;
}

.el-upload-list__item-actions {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.el-upload-list__item-actions:hover {
  opacity: 1;
}

.el-upload-list__item-actions:hover span {
  display: inline-block;
}

.el-upload-list__item-actions span {
  cursor: pointer;
}

.el-icon-zoom-in,
.el-icon-delete {
  color: #fff;
}

.el-upload-list__item-delete {
  position: initial;
}
</style>